import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "@/global/GlobalContext";
import NavEngrave40 from "@/assets/imgs/nav-engrave-40w.webp"
import NavEngrave80 from "@/assets/imgs/nav-engrave-80w.webp"
import DsDsLogoWhite from "@/assets/imgs/dsds-logo-white-2.png"
import DsDsLogoGold from "@/assets/imgs/dsds-logo-gold-2.png"
import DropdownMenuIcon from "@/assets/icons/triangle.webp";
import { faBars, faCartShopping, faCircleUser, faPhone } from "@fortawesome/free-solid-svg-icons";
import { menu } from "@/app/utils/constants";
import clsx from "clsx";
import { Link } from "react-router-dom";
import GreekLine from "./GreekLine";
import { useDispatch } from "react-redux";

export default function NavbarComponent({ children, bgColor, hasGreekL, contentColor }) {
  const { pathname, isToggled, setIsToggled, setOpenGapura, setInitial, openGapura, setShowEnterFont, disabledDropdown, setLoading, setIsShowBG, setIsPlaying, finishToggled, setFinishToggled, authStore, orderStore, notifyError } = useGlobalContext()
  const subMenuRef = useRef(null)
  const mediaSm = window.matchMedia("(min-width: 640px)")
  const [orderCount, setOrderCount] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    setOrderCount(orderStore.orderCount)
  }, [orderStore])

  useEffect(() => {
    const navbarLinks = document.getElementsByClassName("navbar__link")
    for (let navLink of navbarLinks) {
      if (pathname == navLink.getAttribute("href")) {
        navLink.classList.add("text-gray-900")
        navLink.classList.remove("text-gray-500")
        const img = document.createElement("img")
        img.setAttribute("src", NavEngrave40)
        img.setAttribute("srcset", `${NavEngrave40} 40w, ${NavEngrave80} 80w`)
        img.setAttribute("sizes", "(max-width: 768px) 32px, 40px")
        img.setAttribute("alt", "Navigation ornament")
        img.setAttribute("class", "w-8 md:w-10")
        img.setAttribute("loading", "lazy")
        img.setAttribute("decoding", "async")
        navLink.parentElement.appendChild(img)
      } else {
        navLink.classList.remove("active")
      }
    }

    window.scrollTo(0, 0)
  }, [pathname])

  const toggleMenu = () => {
    if (!isToggled) setOpenGapura(isToggled);
    setIsToggled(!isToggled)
    setShowEnterFont(isToggled)
    setInitial(!isToggled && openGapura)
    handleFinishToggled()
  }

  const handleFinishToggled = () => {
    setTimeout(() => {
      setFinishToggled(!finishToggled)
    }, 1000)
  }

  const toggleSubMenu = (id, mode) => {
    if (subMenuRef.current) {
      const selectedEl = document.getElementById(`detailMenu${id}`)
      const selectedEls = document.querySelectorAll(".detail-menus")
      const selectedElDropdownMenu = document.getElementById(`dropdownMenuIcon${id}`)
      const dropdownMenus = document.querySelectorAll(".dropdown-menus")

      if (!mode) mode = selectedEl.classList.contains("hidden") ? "block" : "hidden";
      if (selectedEl) {
        for (const s of selectedEls) {
          if (!selectedEl.isEqualNode(s)) {
            if (s.classList.contains("block")) {
              s.classList.remove("block")
              s.classList.add("hidden")
            }
          }
        }

        for (const d of dropdownMenus) {
          if (!selectedEl.isEqualNode(d)) {
            if (d.classList.contains("rotate-180")) {
              d.classList.remove("rotate-180")
              d.classList.add("rotate-0")
            }
          }
        }

        if (mode == "hidden") {
          selectedEl.classList.remove("block")
          selectedEl.classList.add(mode)
          selectedElDropdownMenu.classList.remove("rotate-180")
          selectedElDropdownMenu.classList.add("rotate-0")
        } else {
          selectedEl.classList.remove("hidden")
          selectedEl.classList.add(mode)
          selectedElDropdownMenu.classList.remove("rotate-0")
          selectedElDropdownMenu.classList.add("rotate-180")
        }
      }
    }
  }

  const onClickLogo = () => {
    setLoading("exit")
    setIsShowBG(true)
    setOpenGapura(true)
    setIsToggled(false)
    setIsPlaying(false)
  }

  return (
    <>
      <header id="header" className={clsx("box-border h-14 sm:h-16 top-0 start-0 fixed w-full z-40", bgColor)}>
        <nav className={clsx("relative h-10 sm:h-12", bgColor)}>
          <div className="w-full flex flex-wrap items-center justify-between pt-3 xs:pt-4 pb-0.5 xs:pb-1 2xl:pb-1.5 md:px-12 px-4">
            <div className="navbar-collapse--left items-center justify-between flex w-auto">
              <ul className="flex flex-row space-x-8">
                <li>
                  <button type="button" disabled={disabledDropdown} onClick={toggleMenu} aria-label={isToggled ? "Close menu" : "Open menu"}>
                    <FontAwesomeIcon icon={faBars} style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }} />
                  </button>
                </li>
                <li className="absolute top-1/2 -translate-y-1/2 md:left-12 left-">
                  <Link to="/" onClick={onClickLogo} className={clsx("navbar__link flex flex-col items-center font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-current="page">
                    <img width="100" src={contentColor == "text-white" && !isToggled ? DsDsLogoWhite : DsDsLogoGold} className="w-6 sm:w-8" alt="DSDS logo" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="items-center justify-between flex w-auto">
              <ul className={clsx("font-medium pb-1 flex flex-row space-x-8", bgColor)}>
                {/* {(!pathname.includes("/di-sana") && !pathname.includes("/cart")) && ( */}
                <>
                  {authStore.isAuth && pathname !== "/auth/login" ? (
                    <li>
                      <Link to="/user/dashboard/profile" onClick={() => setIsToggled(false)} className={clsx("block font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-current="page" aria-label="Open profile" style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }}>
                        <FontAwesomeIcon icon={faCircleUser} />
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link to="/auth/login" onClick={() => setIsToggled(false)} className={clsx("navbar__link flex flex-col items-center font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-current="page" style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }}>Login</Link>
                    </li>
                  )}
                  <li>
                    <Link to="/di-sini/special-events#contactUs" onClick={() => setIsToggled(false)} className={clsx("navbar__link flex flex-col items-center font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-current="page" aria-label="Contact us" style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }}>
                      <FontAwesomeIcon icon={faPhone} />
                    </Link>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/disinidisana.bras" target="_blank" onClick={toggleMenu} className={clsx("block font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-label="DSDS Instagram" style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }}>
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </li>
                </>
                {/* )} */}
                {/* {(pathname.includes("/di-sana") || pathname.includes("/cart")) && ( */}
                {authStore.isAuth && (
                  <li className="relative">
                    <Link to="/cart" onClick={() => setIsToggled(false)} className={clsx("block font-headlines text-sm md:text-lg 2xl:text-xl leading-4 md:leading-5 2xl:leading-6 rounded", contentColor)} aria-label="Open cart" style={{ color: contentColor == "text-white" && !isToggled ? "#ffffff" : "#b99a59" }}>
                      <FontAwesomeIcon icon={faCartShopping} />
                    </Link>
                    {orderCount > 0 &&
                      <div className="absolute -top-1 -right-3 bg-red-600 px-[5px] py-[1px] rounded-full text-[8px] text-white">
                        <span className="relative -top-[0.5px]">{orderCount}</span>
                      </div>
                    }
                  </li>
                )}
                {/* )} */}
              </ul>
            </div>
          </div>
        </nav>
        <GreekLine custCls={clsx("relative", { "hidden": !hasGreekL })} />
        {/* dropdown menu */}
        {/* -translate-y-[calc(100vh+56px)] md:-translate-y-[calc(450px+64px)] lg:-translate-y-[calc(400px+64px)] */}
        <div className={clsx("absolute w-full -z-10 h-[100vh] md:h-[450px] lg:h-[400px] flex justify-center transition-transform duration-1000 ease", { "-translate-y-[calc(100vh+56px)] md:-translate-y-[calc(450px+64px)] lg:-translate-y-[calc(400px+64px)] ": !isToggled }, { "translate-y-[calc(0px-56px)] sm:translate-y-[calc(0px-64px)]": isToggled })}>
          <div className="border-x-2 w-full h-full bg-white flex justify-center items-center overflow-y-auto pt-35 sm:pt-[100px] md:pt-25 lg:pt-15">
            <div className={clsx("relative")}>
              <ul className="grid-container px-4 sm:px-12 lg:px-36">
                {menu.map((m, i) => (
                  <li key={i} className={clsx("text-[#875b0e] main-menu w-full cursor-pointer", { "menu-container--above": i <= 4, "menu-container--below": i > 4, "md:text-end": (i + 1) % 5 == 0, "max-md:flex max-md:justify-end text-end md:text-start": (i + 1) % 4 == 0 })}>
                    <div>
                      {m.details ? (
                        <div className="flex flex-row-reverse gap-1 justify-end">
                          <button type="button" className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mt-1" onClick={() => toggleSubMenu(i)} aria-label={`Toggle ${m.label} submenu`}>
                            <img src={DropdownMenuIcon} id={`dropdownMenuIcon${i}`} alt="" className="dropdown-menus" />
                          </button>
                          {m.label.slice(m.label.length - 4) == "sini" || m.label.slice(m.label.length - 4) == "sana" ? (
                            <>
                              <Link to={m.link} onClick={toggleMenu}>
                                <span className="uppercase font-headlines">{m.label.split("/")[0]}</span>/<span className={clsx("uppercase font-headlines", { "inline-block": !mediaSm.matches })}>{m.label.split("/")[1]}</span>
                              </Link>
                            </>
                          ) : (
                            m.isBlank ? (
                              <a href={m.link} target="_blank" onClick={toggleMenu} className="uppercase font-headlines">{m.label}</a>
                            ) : (
                              <>
                                <Link to={m.link} onClick={toggleMenu} className="uppercase font-headlines">{m.label}</Link>
                              </>
                            )
                          )}
                        </div>
                      ) : (
                        m.isBlank ? (
                          <a href={m.link} target="_blank" onClick={toggleMenu} className="main-menu uppercase font-headlines">{m.label}</a>
                        ) : (
                          m.label == "contact us" ? (
                            <a href={m.link} className="main-menu uppercase font-headlines">{m.label}</a>
                          ) : (
                            <Link to={m.link} onClick={toggleMenu} className="main-menu uppercase font-headlines">{m.label}</Link>
                          )
                        )
                      )}
                      {m.details && (
                        <>
                          <ul ref={subMenuRef} id={`detailMenu${i}`} className="sub-menu hidden text-charcoal-black font-headlines detail-menus">
                            {m.details.map((d, id) => (
                              <li key={id} onClick={() => toggleSubMenu(i, "hidden")}>
                                <Link to={d.link} onClick={toggleMenu}>{d.name}</Link>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </header>
      {children}
    </>
  );
}
